import React from 'react';
import { HtmlEntityEncoder } from '../components/html-entity-encoder/HtmlEntityEncoder';

export const HtmlEntityEncoderPage: React.FC = () => {
  return (
    <div className="page-container">
      <HtmlEntityEncoder />
    </div>
  );
};